import { Effect } from "effect";
import { AddToCartEvents } from "./AddToCartEvents";

const requestId = () =>
  // Browser-friendly ID. (If you need to support older browsers, swap this.)
  crypto.randomUUID();

/**
 * Wrap any effect with lifecycle events.
 */
export const withAddToCartEvents = <A, E>(
  event: SubmitEvent,
  data: unknown,
  inner: Effect.Effect<A, E>,
) =>
  Effect.gen(function* () {
    const events = yield* AddToCartEvents;
    const id = requestId();

    // before
    yield* events.publish({
      _tag: "before",
      requestId: id,
      data,
      submitter: event.submitter,
      form: event.target as HTMLFormElement | null,
    });

    // run + success/error + finally
    return yield* inner.pipe(
      Effect.matchEffect({
        onFailure: (error) =>
          events
            .publish({
              _tag: "error",
              requestId: id,
              data,
              error,
              submitter: event.submitter,
              form: event.target as HTMLFormElement | null,
            })
            .pipe(Effect.zipRight(Effect.fail(error))),
        onSuccess: (result) =>
          events
            .publish({
              _tag: "success",
              requestId: id,
              data,
              result,
              submitter: event.submitter,
              form: event.target as HTMLFormElement | null,
            })
            .pipe(Effect.as(result)),
      }),
      Effect.ensuring(
        events.publish({
          _tag: "finally",
          requestId: id,
          data,
          submitter: event.submitter,
          form: event.target as HTMLFormElement | null,
        }),
      ),
    );
  });
